import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getAppDisplayName } from "../utils/commonMethods";

interface FooterProps {
  //onLinkClick: (linkType: "veiligheidskaart" | "lmra" | "ewp") => void;
}

const Footer: React.FC<FooterProps> = ({ }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const projectName = getAppDisplayName();
  const startYear = new Date().getFullYear();
  const endYear = startYear + 1;

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.info.dark,
        padding: theme.spacing(1),
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        zIndex: 2000
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.secondary.dark,
          fontFamily: "Nunito Sans SemiBold",
          fontSize: "12px",
        }}
      >
        {t("common.text_footer", { startYear, endYear, projectName })}
      </Typography>
    </Box>
  );
};

export default Footer;
